import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { db } from "../FirebaseComp/firebase"; // Ensure you have Firebase configured
import { collection, addDoc } from "firebase/firestore";
import "./contactus.css";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Store form data in Firestore
    try {
      await addDoc(collection(db, "contactus"), formData);
      console.log("Contact saved successfully!");
    } catch (error) {
      console.error("Error saving contact:", error);
    }

    // Send email using EmailJS
    const emailParams = {
      name: formData.name,
      email: formData.email,
      subject: formData.subject,
      message: formData.message,
    };

    emailjs
      .send(
        "service_22or7mg", 
        "template_csbr5rl", 
        emailParams,
        "pNle7yEw5kA2fLPDN" 
      )
      .then(() => {
        alert("Message sent successfully!");
      })
      .catch((error) => {
        console.error("Email sending failed:", error);
      });

    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="contact-container">
      <section className="contact-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you! Get in touch with us for any queries or bookings.</p>
      </section>

      <section className="contact-info-contactus">
        <div className="contact-details-contactus">
          <h2>Our Office</h2>
          <p><strong>Address:</strong> No. 27, Buduruwagala, Wellawaya, Sri Lanka</p>
          <p><strong>Email:</strong> <a href="mailto:infochavotours@gmail.com">infochavotours@gmail.com</a></p>
          <p><strong>Phone:</strong> <a href="tel:+94776937010"> +94 77 693 7010</a></p><br /><br />

        </div>
      </section>

      <section className="contact-form">
        <div className="form-container">
          <div className="form-content">
            <h2>Send Us a Message</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group-contactus">
                <label htmlFor="name">Full Name:</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Your Full Name" required />
              </div>
              
              <div className="form-group-contactus">
                <label htmlFor="email">Email:</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email Address" required />
              </div>
              
              <div className="form-group-contactus">
                <label htmlFor="subject">Subject:</label>
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject of the Message" required />
              </div>
              
              <div className="form-group-contactus">
                <label htmlFor="message">Message:</label>
                <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} placeholder="Your Message" required></textarea>
              </div>
              
              <div className="form-group-contactus">
                <button type="submit" className="submit-btn">Send Message</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactUs;
